<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle></PageTitle>
        <b-card>
          <div class="bd-example">
            <dl class="row">
              <dt class="col-sm-3">{{ $t('page.generic.name') }}</dt>
              <dd class="col-sm-9">{{patientConstraintData.label}}</dd>
              <dt class="col-sm-3">{{ $t('page.generic.code') }}</dt>
              <dd class="col-sm-9">{{patientConstraintData.code}}</dd>
              <dt class="col-sm-3">{{ $t('page.generic.description') }}</dt>
              <dd class="col-sm-9">{{ patientConstraintData.description }}</dd>
              <dt class="col-sm-3" v-if="patientConstraintData.patientConstraintCodingSchema">CodingSchema associato</dt>
              <dd class="col-sm-9" v-if="patientConstraintData.patientConstraintCodingSchema">
                <dl class="row">
                  <dt class="col-sm-3">{{ $t('page.generic.code') }}</dt>
                  <dd class="col-sm-9">
                    <b-badge :variant="`warning`">
                      {{ patientConstraintData.patientConstraintCodingSchema.code }}
                    </b-badge>
                  </dd>
                  <dt class="col-sm-3">{{ $t('page.generic.name') }}</dt>
                  <dd class="col-sm-9">{{patientConstraintData.patientConstraintCodingSchema.label}}</dd>
                </dl>
              </dd>
            </dl>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import miniToastr from 'mini-toastr' //ES6
  import PageTitle from '../../components/PageTitle'
  import PatientConstraintService from '@/services/PatientConstraintService'

  const patientConstraintService = PatientConstraintService.build();

  export default {
    name: 'ConstraintShow',
    props: {
      id: {
        required: true
      }
    },
    components: {
      PageTitle
    },
    data() {
      return {
        deleteModal: false,
        patientConstraintData: ''
      }
    },
    created() {
      miniToastr.init(); // config can be passed here miniToastr.init(config)
      miniToastr.setIcon('info', 'i', {'class': 'fas fa-info-circle'});
      this.fetchData()
    },
    methods: {
      async fetchData() {
        this.patientConstraintData = await patientConstraintService.read(this.id)
      }
    }
  }
</script>
